import angular from 'angular';
import _ from 'underscore';
import moment from 'moment';
import accounting from 'accounting';

import admissionGroupCheckInPanelTemplate from 'panels/admissionGroupCheckIn/template.html';
import cancelAdmissionGroupPanelTemplate from 'panels/cancelAdmissionGroup/template.html';
import addAdmissionGroupReceiptsPanelTemplate from 'panels/addAdmissionGroupReceipts/template.html';

function _mapLayoutTables(layoutTables) {
  const numberRegex = new RegExp(/^[0-9]*$/ig);

  _.each(layoutTables, layoutTable => {
    if (layoutTable.name && _.isString(layoutTable.name) && layoutTable.name.match(numberRegex)) {
      layoutTable.name = parseInt(layoutTable.name, 10);
    }
  });

  return layoutTables;
}

class AddAdmissionGroupCtrl {
  constructor($scope, $q, $timeout, colorService, dateUtilsService, mapperService, customerService, sdkUtils, organizationService, alertService, layoutTableService, layoutService, formHelpersService, admissionGroupService, attributionSourceService, managementUserService, serverService, permissionService, inventoryService, angularSlideOutPanel, sdkVenueService, outgoingPaymentService, $sce, confirmationRequestService, supportService, modalService, bookingService) { //eslint-disable-line
    this._$scope = $scope;
    this._$q = $q;
    this._$timeout = $timeout;
    this._colorService = colorService;
    this._dateUtilsService = dateUtilsService;
    this._mapperService = mapperService;
    this._customerService = customerService;
    this._sdkUtils = sdkUtils;
    this._organizationService = organizationService;
    this._alertService = alertService;
    this._layoutTableService = layoutTableService;
    this._layoutService = layoutService;
    this._formHelpersService = formHelpersService;
    this._admissionGroupService = admissionGroupService;
    this._attributionSourceService = attributionSourceService;
    this._managementUserService = managementUserService;
    this._serverService = serverService;
    this._permissionService = permissionService;
    this._inventoryService = inventoryService;
    this._angularSlideOutPanel = angularSlideOutPanel;
    this._sdkVenueService = sdkVenueService;
    this._outgoingPaymentService = outgoingPaymentService;
    this._$sce = $sce;
    this._confirmationRequestService = confirmationRequestService;
    this._supportService = supportService;
    this._modalService = modalService;
    this._bookingService = bookingService;
    this.compTypes = [{
      key: 'Birthday',
      value: 'BIRTHDAY'
    }, {
      key: 'Promoter',
      value: 'PROMOTER'
    }, {
      key: 'Industry',
      value: 'INDUSTRY'
    }, {
      key: 'Influencer',
      value: 'INFLUENCER'
    }, {
      key: 'Owner',
      value: 'OWNER'
    }, {
      key: 'Artist or Talent',
      value: 'ARTIST_OR_TALENT'
    }, {
      key: 'Other',
      value: 'OTHER'
    }];

    this.paymentRequestPanelHandle = {};

    this._supportService.hide();

    this.loading = true;
    this.venue = $scope.venue;
    this.events = $scope.events;
    this.eventId = $scope.eventId;
    this.venueBrandColors = this.venue.branding ? {
      primaryColor: this.venue.branding.primaryColor ? colorService.rgbToHex(this.venue.branding.primaryColor.red, this.venue.branding.primaryColor.green, this.venue.branding.primaryColor.blue) : '#000' //eslint-disable-line
    } : {};
    this.type = $scope.type;
    this.onAddedOrUpdated = $scope.onAddedOrUpdated;
    this.date = this._dateUtilsService.toUTCMomentWithoutTime($scope.date);
    this.admissionGroup = $scope.admissionGroup;
    this.editMode = !!this.admissionGroup;
    this.popupState = {
      customerMode: false,
      attributionSourceMode: false
    };
    this.currentPanel = 'RESERVATION_GUESTLIST_PANEL';
    this.currentAdmissionGroupPanel = this.editMode ? 'READ' : 'READ_WRITE';
    this.customerAdmissionGroupsLoaded = false;

    // permission
    this.canRead = false;
    this.canWrite = false;
    this.canManageCustomers = false;

    if (!this.venue) throw new Error('add-admission-group directive - venue is required on scope');
    if (!this.type) throw new Error('add-admission-group directive - type is required on scope');
    if (!this.date) throw new Error('add-admission-group directive - date is required on scope');
    if (!_.isDate(this.date) && !moment.isMoment(this.date)) throw new Error('add-admission-group directive - date must be a Date object or a Moment object');

    // ----------- bound functions ---------- //
    //NOTE: because this is a click handler bind to 'this' - otherise it'll be the addAdmissionGroupCustomerCtrl that gets bound to 'this'

    this.onCustomerChanged = angular.bind(this, function (customer) {
      this.hideCustomerMode();

      this.customer = this.mapCustomer(customer);
      this.addAdmissionGroupForm.customer = customer.id;
    });

    this.onAttributionSourceChanged = angular.bind(this, function (attributionSource) {
      this.hideAttributionSourceMode();

      this.attributionSource = attributionSource;
    });

    this.groupLayoutTables = angular.bind(this, function (item) {
      const layout = _.findWhere(this.layouts, {
        id: item.layout
      });

      return layout ? layout.name : '';
    });

    // ----------- load data ---------- //

    if (this.editMode) {
      this.addAdmissionGroupForm = mapperService.mapAdmissionGroupToUI(this.admissionGroup);

      if (this.addAdmissionGroupForm.customer) {
        this.getCustomer(this.addAdmissionGroupForm.customer)
          .then(customer => {
            this.customer = customer;
          });
      }

      if (!this.isExternalOrganization()) {
        const promises = [
          this.getOutgoingPayments(this.admissionGroup.id),
          permissionService.canWriteVenue(this.venue.id)
          .then(hasPermission => {
            if (hasPermission) return this.getBookings(this.admissionGroup.id);
            return null;
          })
        ];

        $q.all(promises);
      }

      if (this.addAdmissionGroupForm.orderSummary) {
        //each item of the order in a new line
        const lines = this.addAdmissionGroupForm.orderSummary.split('\n');

        let details = '';

        _.each(lines, line => {
          if (line !== 'Items:') {
            details = `${details} ${line} <br>`;
          }
        });

        this.addAdmissionGroupForm.orderSummaryHtml = this._$sce.trustAsHtml(details);
      }

      if (this.addAdmissionGroupForm.inventoryDescription) {
        this.addAdmissionGroupForm.inventoryDescriptionHtml = this._$sce.trustAsHtml(this.addAdmissionGroupForm.inventoryDescription);
      }
    } else {
      this.addAdmissionGroupForm = {
        venue: this.venue.id,
        event: this.eventId,
        type: this.type,
        date: this.date,
        guestsExpectedUnisex: 1,
        guestsExpectedMale: 0,
        guestsExpectedFemale: 0
      };

      if (!this.eventId) this.addAdmissionGroupForm.event = this.events && this.events.length ? this.events[0].id : null;
    }

    const promises = [
      this.getPermissionsByVenueId(this.venue.id, this.venue.organization),
      this.getAttributionSources(),
      this.getAttributionSourcesForCurrentUser()
    ];

    if (!this.isExternalOrganization()) {
      promises.push(this.getOrganizationServers());
    }

    if (this.addAdmissionGroupForm.type === 'TABLE') {
      promises.push(this.getLayoutsByVenueId(this.venue.id));
      promises.push(this.getLayoutTablesByVenueId(this.venue.id));
    } else {
      promises.push(this.getInventoryByVenueId(this.venue.id));
    }

    this._$q.all(promises)
      .then(() => {
        this.loading = false;

        //when creating set the attribution to the current user
        if (!this.editMode && this.currentUserAttributionSource) {
          this.attributionSource = _.findWhere(this.attributionSources, {
            id: this.currentUserAttributionSource.id
          });
        }
      });

    if (this._$scope.currentTab === 'RECEIPTS') {
      this.currentPanel = 'RECEIPTS_PANEL';
    } else if (this._$scope.currentTab === 'CHECK_IN') {
      this.checkInAdmissionGroup();
    }

    this.onPosSyncEnabledChanged = (function () {
      let modalInstance;

      if (this.admissionGroup.posSyncEnabled) {
        return this._modalService.confirmation({
            modalHeader: 'Disable POS Syncing',
            modalMessage: 'Are you sure you want to disable POS syncing on this reservation? Disabling will switch back to using receipts.',
            confirmBtnTxt: 'Disable',
            confirmingBtnTxt: 'Saving...',
            confirmingBtnClass: 'btn-danger'
          })
          .then(result => {
            modalInstance = result.modalInstance;

            if (result && result.confirm) {
              return this._admissionGroupService.updateById(this.admissionGroup.id, {
                  posSyncEnabled: false
                })
                .then(admissionGroup => {
                  this.admissionGroup = admissionGroup;
                  this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);

                  this._alertService.success(this.admissionGroup.posSyncEnabled ? 'POS Syncing Enabled' : 'POS Syncing Disabled');

                  this.onAddedOrUpdated({
                    deleted: false,
                    admissionGroup: this.admissionGroup,
                    notify: false
                  });

                  modalInstance.close();
                })
                .catch(error => {
                  this.savingAdmissionGroup = false;
                  this._alertService.error(this._sdkUtils.getErrorFromResponse(error));

                  modalInstance.close();
                });
            }

            return null;
          })
          .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
      }

      return this._admissionGroupService.updateById(this.admissionGroup.id, {
          posSyncEnabled: true
        })
        .then(admissionGroup => {
          this.admissionGroup = admissionGroup;
          this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);

          this.onAddedOrUpdated({
            deleted: false,
            admissionGroup: this.admissionGroup,
            notify: false
          });

          this._alertService.success('POS Syncing Enabled');
        })
        .catch(error => {
          this.savingAdmissionGroup = false;
          this._alertService.error(this._sdkUtils.getErrorFromResponse(error));
        });
    }).bind(this);
  }

  isExternalOrganization() {
    if (!this.venue) return true;
    return this._permissionService.isExternalOrganization(this.venue.organization);
  }

  canViewCustomerInformation() {
    return this.canManageCustomers && !this.isExternalOrganization();
  }

  canPerformActions() {
    return !this.isExternalOrganization() && this.canWrite;
  }

  closePanel($event) {
    if ($event) $event.preventDefault();

    this.hideCustomerMode();

    this.hideAttributionSourceMode();

    this._supportService.show();

    this._$timeout(() => {
      this._$scope.cancel();
    });
  }

  cancelReadWriteMode($event) {
    if ($event) $event.preventDefault();

    this.currentAdmissionGroupPanel = 'READ';

    this.hideCustomerMode();
    this.hideAttributionSourceMode();
  }

  cancelAdmissionGroup($event) {
    if ($event) $event.preventDefault();

    if (!this.admissionGroup || this.admissionGroup.status === 'CANCELLED') return;

    const openBookings = this.bookings;

    if (openBookings && openBookings.length && this.canRefundOrders) {
      let modalInstance;

      this._modalService.confirmation({
          modalHeader: 'Refund Orders',
          modalMessage: `This ${this.addAdmissionGroupForm.type.toLowerCase()} has ${openBookings.length} order${openBookings.length === 1 ? '' : 's'} associated with it. Before you cancel would you like to refund them?`, //eslint-disable-line
          confirmBtnTxt: 'Refund Orders',
          confirmingBtnTxt: 'Refunding...'
        })
        .then(result => {
          modalInstance = result.modalInstance;

          if (result && result.confirm) {
            const promises = openBookings.map(booking => {
              return this._bookingService.performAction(booking.id, 'CANCEL')
                .then(updatedBooking => {
                  booking = _.extend(booking, updatedBooking);
                });
            });

            return this._$q.all(promises);
          }

          return null;
        })
        .then(() => {

          modalInstance.close();

          if (this.onAddedOrUpdated) {
            this.onAddedOrUpdated({
              deleted: true,
              admissionGroup: this.admissionGroup
            });
          }
        })
        .catch(response => {
          modalInstance.close();

          this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
        });
    } else {
      this._cancelAdmissionGroup();
    }
  }

  removePosTicket(posTicket) {
    let modalInstance;

    if (this.admissionGroup.posSyncEnabled) {
      return this._modalService.confirmation({
          modalHeader: 'Remove POS Ticket',
          modalMessage: 'Are you sure you want to remove this POS Ticket from your reservation?',
          confirmBtnTxt: 'Remove',
          confirmingBtnTxt: 'Saving...',
          confirmingBtnClass: 'btn-danger'
        })
        .then(result => {
          modalInstance = result.modalInstance;

          return this._admissionGroupService.performActionById(this.admissionGroup.id, {
              type: 'REMOVE_POS_TICKET',
              posTicketId: posTicket.id
            })
            .then(admissionGroup => {
              this.admissionGroup = admissionGroup;
              this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);

              this._alertService.success('POS Ticket Removed');

              if (this.onAddedOrUpdated) {
                this.onAddedOrUpdated({
                  deleted: false,
                  admissionGroup: this.admissionGroup
                });
              }

              modalInstance.close();
            })
            .catch(error => {
              this.savingAdmissionGroup = false;
              this._alertService.error(this._sdkUtils.getErrorFromResponse(error));

              modalInstance.close();
            });
        })
        .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
    }

    return this._admissionGroupService.updateById(this.admissionGroup.id, {
        posSyncEnabled: true
      })
      .then(admissionGroup => {
        this.admissionGroup = admissionGroup;
        this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);

        this._alertService.success('POS Syncing Enabled');
      })
      .catch(error => {
        this.savingAdmissionGroup = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(error));
      });
  }

  uncancelAdmissionGroup($event) {
    if ($event) $event.preventDefault();

    if (!this.admissionGroup || this.admissionGroup.status !== 'CANCELLED') return;

    this._admissionGroupService.updateById(this.admissionGroup.id, {
        status: 'CONFIRMED'
      })
      .then(admissionGroup => {
        _.extend(this.admissionGroup, admissionGroup);
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  _cancelAdmissionGroup() {
    const panelInstance = this._angularSlideOutPanel.open({
      template: cancelAdmissionGroupPanelTemplate,
      openOn: 'right',
      controller: 'cancelAdmissionGroupPanelCtrl',
      backdrop: 'static',
      resolve: {
        venue: [
          () => {
            return this.venue;
          }
        ],
        admissionGroup: [
          () => {
            return this.admissionGroup;
          }
        ],
        date: [
          () => {
            return this.date;
          }
        ],
        type: [
          () => {
            return this.addAdmissionGroupForm.type;
          }
        ]
      }
    });

    panelInstance.result
      .then(result => {
        if (result === false) return;

        if (result.cancelled) {
          _.extend(this.admissionGroup, result.admissionGroup);

          this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);

          if (this.onAddedOrUpdated) {
            this.onAddedOrUpdated({
              admissionGroup: this.admissionGroup
            });
          }

          this.closePanel();
        }
      });
  }

  deleteAdmissionGroup($event) {
    if ($event) $event.preventDefault();

    if (!this.admissionGroup || this.admissionGroup.deleted) return;

    let modalInstance;

    this._modalService.confirmation({
        modalHeader: this.addAdmissionGroupForm.type === 'TABLE' ? 'Delete Reservation' : 'Delete Guestlist',
        modalMessage: this.addAdmissionGroupForm.type === 'TABLE' ? 'Are you sure you want to delete this reservation?' : 'Are you sure you want to delete this guestlist?',
        confirmBtnTxt: this.addAdmissionGroupForm.type === 'TABLE' ? 'Delete Reservation' : 'Delete Guestlist',
        confirmingBtnTxt: 'Deleting...'
      })
      .then(result => { //eslint-disable-line
        modalInstance = result.modalInstance;

        if (result && result.confirm) {
          return this._admissionGroupService.deleteById(this.admissionGroup.id)
            .then(updatedAdmissionGroup => {
              this.admissionGroup = _.extend(this.admissionGroup, updatedAdmissionGroup);
            });
        }
      })
      .then(() => {
        this.closePanel();

        modalInstance.close();

        if (this.onAddedOrUpdated) {
          this.onAddedOrUpdated({
            deleted: true,
            admissionGroup: this.admissionGroup
          });
        }
      })
      .catch(response => {
        modalInstance.close();

        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  changeCurrentPanel(panelName, $event) {
    if ($event) $event.preventDefault();

    if (panelName !== 'RESERVATION_GUESTLIST_PANEL') {
      this.hideCustomerMode();
      this.hideAttributionSourceMode();
    }
    if (panelName === 'CUSTOMER_PROFILE_PANEL') {
      if (!this.customer) return;

      if (!this.customerAdmissionGroupsLoaded) {
        this.getCustomerAdmissionGroups(this.customer.id);
      }
    }
    if (panelName === 'PAYMENT_REQUESTS_PANEL') {
      this.getPaymentRequests(this.admissionGroup.id);
    }

    this.currentPanel = panelName;

    if (panelName !== 'RESERVATION_GUESTLIST_PANEL') {
      this.cancelReadWriteMode();
    }
  }

  changeCurrentAdmissionGroupPanel(panelName, $event) {
    if ($event) $event.preventDefault();

    this.currentAdmissionGroupPanel = panelName;

    if (this.currentAdmissionGroupPanel === 'READ_WRITE') {
      this.currentPanel = 'RESERVATION_GUESTLIST_PANEL';
    }
  }

  changeCustomer($event) {
    if ($event) $event.preventDefault();

    this.hideAttributionSourceMode();

    if (this.popupState.customerMode) {
      this.hideCustomerMode();
    } else {
      this.popupState.customerMode = true;
    }
  }

  isBookingCancelled(booking) { //eslint-disable-line
    if (!booking) return true;

    return booking.status === 'CANCEL_PENDING' ||
      booking.status === 'CANCELLED' ||
      booking.status === 'VOID_PENDING' ||
      booking.status === 'VOIDED' ||
      booking.status === 'REFUND_PENDING' ||
      booking.status === 'REFUNDED' ||
      booking.status === 'EXPIRE_PENDING' ||
      booking.status === 'EXPIRED';
  }

  removeCustomer($event) {
    if ($event) $event.preventDefault();

    this.hideCustomerMode();

    this.customer = null;
    delete this.addAdmissionGroupForm.customer;
    delete this.addAdmissionGroupForm.name;
    delete this.addAdmissionGroupForm.firstName;
    delete this.addAdmissionGroupForm.lastName;
  }

  changeAttributionSource($event) {
    if ($event) $event.preventDefault();

    if (this.isExternalOrganization()) return;

    this.hideCustomerMode();

    if (this.popupState.attributionSourceMode) {
      this.hideAttributionSourceMode();
    } else {
      this.popupState.attributionSourceMode = true;
    }
  }

  removeAttributionSource($event) {
    if ($event) $event.preventDefault();

    this.hideAttributionSourceMode();

    this.attributionSource = null;
    delete this.addAdmissionGroupForm.attributionId;
    delete this.addAdmissionGroupForm.attributionType;
  }

  getCustomer(customerId) {
    if (!customerId) throw new Error('customerId');

    const currentUserOrganization = this._organizationService.getCurrentOrganization();

    return this._customerService.readByIdAndOrganizationId(customerId, currentUserOrganization.id)
      .then(customer => {
        return this.mapCustomer(customer);
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  mapCustomer(customer) { //eslint-disable-line
    if (!customer) throw new Error('customer');

    if (customer.stats) {
      if (customer.stats.firstVisit) customer.stats.firstVisit = moment.utc(customer.stats.firstVisit);
      if (customer.stats.latestVisit) customer.stats.latestVisit = moment.utc(customer.stats.latestVisit);
    }

    if (customer.birthdayMonth && customer.birthdayDay && customer.birthdayYear) {
      customer.birthday = moment.utc();
      customer.birthday.set('year', customer.birthdayYear);
      customer.birthday.set('month', customer.birthdayMonth - 1);
      customer.birthday.set('date', customer.birthdayDay);
    }

    return customer;
  }

  getAttributionSources() {
    return this._attributionSourceService.listByOrganizationId(this.venue.organization)
      .then(attributionSources => {
        this.attributionSources = attributionSources;

        if (this.editMode && this.admissionGroup.attributionId) {
          this.attributionSource = _.findWhere(this.attributionSources, {
            id: this.admissionGroup.attributionId
          });

          //if the attribution source was deleted need to handle and still show something in the UI
          if (this.admissionGroup.attributionId && !this.attributionSource) {
            this.attributionSource = {
              id: this.admissionGroup.attributionId,
              name: this.admissionGroup.attributionName,
              type: this.admissionGroup.attributionType
            };
          }
        } else {
          const currentUser = this._managementUserService.getCurrentUser();

          if (!this.isExternalOrganization()) {
            this.attributionSource = _.findWhere(this.attributionSources, {
              id: currentUser.id
            });
          }
        }
      })
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  getAttributionSourcesForCurrentUser() {
    const currentUserOrganization = this._organizationService.getCurrentOrganization();
    const currentUser = this._managementUserService.getCurrentUser();

    return this._attributionSourceService.listByManagementUserId(currentUser.id, {
        organizationId: currentUserOrganization.id
      })
      .then(attributionSources => {
        this.currentUserAttributionSource = attributionSources[0];
      })
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  hideCustomerMode() {
    this.popupState.hidingCustomerMode = true;

    this._$timeout(() => {
      this.popupState.customerMode = false;
      this.popupState.hidingCustomerMode = false;
    }, 50);
  }

  hideAttributionSourceMode() {
    this.popupState.hidingAttributionSourceMode = true;

    this._$timeout(() => {
      this.popupState.attributionSourceMode = false;
      this.popupState.hidingAttributionSourceMode = false;
    }, 50);
  }

  addOrUpdateAdmissionGroup(angularForm, $event) {
    if ($event) $event.preventDefault();

    this.submitted = true;

    if (!angularForm.$valid) return;

    this.savingAdmissionGroup = true;

    const changedValues = this.editMode ? this._formHelpersService.getChangedFormValues(angularForm) : this.addAdmissionGroupForm;
    changedValues.customer = this.customer.id;
    changedValues.name = this.customer.name;
    changedValues.email = this.customer.email;
    changedValues.phone = this.customer.phone;
    changedValues.gender = this.customer.gender;
    changedValues.birthdayDay = this.customer.birthdayDay;
    changedValues.birthdayMonth = this.customer.birthdayMonth;
    changedValues.birthdayYear = this.customer.birthdayYear;
    changedValues.vip = this.customer.vip;

    changedValues.guestsExpectedUnisex = this.addAdmissionGroupForm.guestsExpectedUnisex;
    changedValues.guestsExpectedMale = this.addAdmissionGroupForm.guestsExpectedMale;
    changedValues.guestsExpectedFemale = this.addAdmissionGroupForm.guestsExpectedFemale;

    if (this.editMode) {
      if ('arrivalTime' in changedValues) changedValues.date = this.addAdmissionGroupForm.date;
      if ('minimumSpend' in changedValues) changedValues.minimumBottles = null;
      if ('minimumBottles' in changedValues && changedValues.minimumBottles !== null) changedValues.minimumSpend = null;
    } else if (this.server && this.server.id !== 'None') {
      changedValues.serverId = this.server.id;
    }

    if (this.attributionSource) {
      changedValues.attributionId = this.attributionSource.id;
      changedValues.attributionType = this.attributionSource.type;
    } else {
      changedValues.attributionId = null;
      changedValues.attributionType = null;
    }

    if (changedValues.server) {
      if (changedValues.server.id === 'None') {
        changedValues.serverId = null;
      } else {
        changedValues.serverId = changedValues.server.id;
      }

      delete changedValues.server;
    }

    const data = this._mapperService.mapAdmissionGroupToAPI(changedValues, {
      create: !this.editMode
    });

    const createOrUpdateAdmissionGroupPromise = this.editMode ?
      this._admissionGroupService.updateById(this.admissionGroup.id, data) :
      this._admissionGroupService.create(data);

    createOrUpdateAdmissionGroupPromise
      .then(admissionGroup => {
        this.savingAdmissionGroup = false;

        if (this.onAddedOrUpdated) {
          this.onAddedOrUpdated({
            created: !this.editMode,
            admissionGroup
          });
        }

        if (this.shouldSendCustomerConfirmationEmail) {
          this._sendCustomerConfirmationEmail(admissionGroup.id);
        }

        this.admissionGroup = admissionGroup;

        if (!this.editMode && this.admissionGroup.type === 'TICKET') {
          this.editMode = true;

          this.changeCurrentPanel('PAYMENT_REQUESTS_PANEL');

          this._$timeout(() => {
            this.paymentRequestPanelHandle.addPaymentRequest();
          }, 200);
        }

        this.editMode = true;
        this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);
        this.currentAdmissionGroupPanel = 'READ';
        this.shouldSendCustomerConfirmationEmail = false;
      })
      .catch(error => {
        this.savingAdmissionGroup = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(error));
      });
  }

  approveDenyAdmissionGroup(approve, $event) {
    if ($event) $event.preventDefault();

    this.savingAdmissionGroup = true;

    return this._admissionGroupService.updateById(this.admissionGroup.id, {
        status: approve ? 'CONFIRMED' : 'DENIED'
      })
      .then(admissionGroup => {
        this.savingAdmissionGroup = false;

        if (this.onAddedOrUpdated) {
          this.onAddedOrUpdated({
            created: false,
            admissionGroup
          });
        }

        this.admissionGroup = admissionGroup;
        this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);

        if (!approve) {
          this.closePanel();
        }
      })
      .catch(error => {
        this.savingAdmissionGroup = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(error));
      });
  }

  closeAdmissionGroup(close, $event) {
    if ($event) $event.preventDefault();

    this.savingAdmissionGroup = true;

    return this._admissionGroupService.updateById(this.admissionGroup.id, {
        closed: close
      })
      .then(admissionGroup => {
        this.savingAdmissionGroup = false;

        _.extend(this.admissionGroup, admissionGroup);

        if (this.onAddedOrUpdated) {
          this.onAddedOrUpdated({
            created: !this.editMode,
            admissionGroup
          });
        }

        this.currentPanel = 'RECEIPTS_PANEL';
      })
      .catch(error => {
        this.savingAdmissionGroup = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(error));
      });
  }

  checkInAdmissionGroup(angularForm, $event) {
    if ($event) $event.preventDefault();

    const panelInstance = this._angularSlideOutPanel.open({
      template: admissionGroupCheckInPanelTemplate,
      openOn: 'right',
      controller: 'admissionGroupCheckinPanelCtrl',
      backdrop: 'static',
      resolve: {
        venue: [
          () => {
            return this.venue;
          }
        ],
        admissionGroup: [
          () => {
            return this.admissionGroup;
          }
        ],
        date: [
          () => {
            return this.date;
          }
        ]
      }
    });

    panelInstance.result
      .then(result => {
        if (result === false) return;

        if (result.admissionGroup) {
          _.extend(this.admissionGroup, result.admissionGroup);

          this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);

          if (this.onAddedOrUpdated) {
            this.onAddedOrUpdated({
              created: !this.editMode,
              admissionGroup: this.admissionGroup
            });
          }
        }
      });
  }

  addReceiptsToAdmissionGroup($event) {
    if ($event) $event.preventDefault();

    const panelInstance = this._angularSlideOutPanel.open({
      template: addAdmissionGroupReceiptsPanelTemplate,
      openOn: 'right',
      controller: 'addAdmissionGroupReceiptsPanelCtrl',
      backdrop: 'static',
      resolve: {
        venue: [
          () => {
            return this.venue;
          }
        ],
        admissionGroup: [
          () => {
            return this.admissionGroup;
          }
        ],
        date: [
          () => {
            return this.date;
          }
        ]
      }
    });

    panelInstance.result
      .then(result => {
        if (result.admissionGroup) {
          _.extend(this.admissionGroup, result.admissionGroup);

          this.addAdmissionGroupForm = this._mapperService.mapAdmissionGroupToUI(this.admissionGroup);
        }
      });
  }

  getLayoutsByVenueId(venueId) {
    if (!venueId) throw new Error('venueId');

    return this._layoutService.listByVenueId(venueId)
      .then(layouts => {
        this.layouts = _.filter(layouts, layout => !layout.deleted);
      })
      .catch(error => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(error));
      });
  }

  getLayoutTablesByVenueId(venueId) {
    if (!venueId) throw new Error('venueId');

    return this._layoutTableService.listByVenueId(venueId)
      .then(layoutTables => {
        this.layoutTables = _mapLayoutTables(layoutTables);
      })
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  getCustomerAdmissionGroups(customerId) {
    if (!customerId) throw new Error('customerId');

    this.loadingCustomerAdmissionGroups = true;

    const currentUserOrganization = this._organizationService.getCurrentOrganization();

    return this._$q.all([
        this._admissionGroupService.listByCustomerId(customerId),
        this._sdkVenueService.listByOrganizationId(currentUserOrganization.id)
      ])
      .then(results => {
        this.customerAdmissionGroupsLoaded = true;
        this.loadingCustomerAdmissionGroups = false;
        this.customerAdmissionGroups = results[0].map(admissionGroup => {
          admissionGroup.date = moment(admissionGroup.date, 'x');
          admissionGroup.venue = _.findWhere(results[1], {
            id: admissionGroup.venue
          });
          return admissionGroup;
        });
      })
      .catch(response => {
        this.loadingCustomerAdmissionGroups = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  getOrganizationServers() {
    const currentUserOrganization = this._organizationService.getCurrentOrganization();

    return this._serverService.listByOrganizationId(currentUserOrganization.id, {
        venueId: this.venue.id
      })
      .then(staffMembers => {
        this.staffMembers = staffMembers;

        this.staffMembers.unshift({
          id: 'None',
          firstName: 'None'
        });

        if (this.editMode && this.admissionGroup.server) {
          this.server = _.findWhere(this.staffMembers, {
            id: this.admissionGroup.server
          });
        }
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  sendCustomerConfirmationEmail(admissionGroupId, $event) {
    if ($event) $event.preventDefault();

    let modalInstance;

    return this._modalService.confirmation({
        modalHeader: 'Send Confirmation Email',
        modalMessage: 'Are you sure you want to send a confirmation email?',
        confirmBtnTxt: 'Send',
        confirmingBtnTxt: 'Sending...',
        confirmingBtnClass: 'btn-success'
      })
      .then(result => {
        modalInstance = result.modalInstance;

        if (result && result.confirm) {
          return this._sendCustomerConfirmationEmail(admissionGroupId);
        }

        return null;
      })
      .then(() => {
        modalInstance.close();
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  getInventoryByVenueId(venueId) {
    if (!venueId) throw new Error('venueId');

    return this._inventoryService.list({
        venueId: venueId,
        start: this._dateUtilsService.toUTCTimestampWithoutTime(this.date),
        end: this._dateUtilsService.toUTCTimestampWithoutTime(this.date),
        type: 'COVER'
      })
      .then(inventory => {
        this.inventory = _.where(inventory, {
          deleted: false
        });
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  getPermissionsByVenueId(venueId, venueOrganizationId) {
    if (!venueId) throw new Error('venueId');
    if (!venueOrganizationId) throw new Error('venueOrganizationId');

    const canWrite = (this.addAdmissionGroupForm.type === 'TABLE' || this.addAdmissionGroupForm.type === 'PACKAGE') ?
      this._permissionService.canWriteReservations(venueId) :
      this._permissionService.canWriteGuestlists(venueId);
    const canRead = (this.addAdmissionGroupForm.type === 'TABLE' || this.addAdmissionGroupForm.type === 'PACKAGE') ?
      this._permissionService.canReadOrWriteReservations(venueId) :
      this._permissionService.canReadOrWriteGuestlists(venueId);
    const canManageCustomers = this._permissionService.canManageCustomers(venueOrganizationId);

    return this._$q.all({
      canWrite,
      canRead,
      canManageCustomers
    }).then(results => {
      this.canRead = results.canRead;
      this.canWrite = results.canWrite;
      this.canManageCustomers = results.canManageCustomers;

    }).catch(response => {
      this.hasPermission = false;
      this.canManageCustomers = false;

      this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
    });
  }

  getTableFloorName(table) {
    const layoutTable = _.findWhere(this.layoutTables, {
      id: table.id
    });

    if (!layoutTable) return '';

    const layout = _.findWhere(this.layouts, {
      id: layoutTable.layout
    });

    return layout ? layout.name : '';
  }

  getOutgoingPayments(admissionGroupId) {
    if (!admissionGroupId) throw new Error('admissionGroupId');

    return this._outgoingPaymentService.listByAdmissionGroupId(admissionGroupId)
      .then(outgoingPayments => {
        this.outgoingPayments = outgoingPayments;

        if (this.outgoingPayments && this.outgoingPayments.length) {
          this.outgoingPayment = this.outgoingPayments[0];
          this.outgoingPayment.data.expiration = moment(this.outgoingPayment.data.expiration, 'x');
          this.outgoingPayment.amount = accounting.formatMoney(this.outgoingPayment.amount);
        }

        if (this.addAdmissionGroupForm.minimum) {
          this.addAdmissionGroupForm.minimumHtml = accounting.formatMoney(this.addAdmissionGroupForm.minimum);
        }
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  getPaymentRequests(admissionGroupId) {
    if (!admissionGroupId) throw new Error('admissionGroupId');

    return this._confirmationRequestService.listByAdmissionGroupId(admissionGroupId)
      .then(paymentRequests => {
        this.paymentRequests = paymentRequests;
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  getInitialsFromName(name) { //eslint-disable-line
    if (!name) return '';

    const parts = name.split(' ');

    return parts.length > 1 ? `${parts[0].substring(0, 1)}${parts[parts.length - 1].substring(0, 1)}` : parts[0].substring(0, 1);
  }

  getFraudStatusBadgeClassByFraudStatus(fraudStatus) { //eslint-disable-line
    if (!fraudStatus) return null;

    if (fraudStatus === 'LOW') return 'badge-fraud-low';
    else if (fraudStatus === 'MEDIUM') return 'badge-fraud-medium';
    else if (fraudStatus === 'HIGH') return 'badge-fraud-high';
    return '';
  }

  getBookings(admissionGroupId) {
    if (!admissionGroupId) throw new Error('admissionGroupId');

    return this._bookingService.listByAdmissionGroupId(admissionGroupId)
      .then(bookings => {
        this.bookings = _.filter(bookings || [], booking => {
          return booking.status === 'COMPLETE' || booking.status === 'PROCESSED';
        });
      })
      .catch(response => this._alertService.error(this._sdkUtils.getErrorFromResponse(response)));
  }

  refundBooking(booking, $event) {
    if ($event) $event.preventDefault();

    let modalInstance;

    this._modalService.confirmation({
        modalHeader: 'Refund Order',
        modalMessage: 'Are you sure you want to refund this order?',
        confirmBtnTxt: 'Refund Order',
        confirmingBtnTxt: 'Refunding...'
      })
      .then(result => {
        modalInstance = result.modalInstance;

        if (result && result.confirm) {
          return this._bookingService.performAction(booking.id, 'CANCEL')
            .then(updatedBooking => {
              booking = _.extend(booking, updatedBooking);

              this._admissionGroupService.readById(this.admissionGroup.id)
                .then(admissionGroup => {
                  this.admissionGroup = _.extend(this.admissionGroup, admissionGroup);

                  this._alertService.success('Order Has Been Refunded');

                  if (this.canWrite) this.getBookings(this.admissionGroup.id);
                });
            });
        }

        return null;
      })
      .then(() => {
        modalInstance.close();
      })
      .catch(response => {
        modalInstance.close();

        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  _sendCustomerConfirmationEmail(admissionGroupId) {
    if (!admissionGroupId) throw new Error('admissionGroupId');

    const type = (this.editMode) ? 'SEND_CUSTOMER_CONFIRMATION_UPDATE' : 'SEND_CUSTOMER_CONFIRMATION_CREATE';

    return this._admissionGroupService.performActionById(admissionGroupId, {
        type
      })
      .catch(response => {
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      })
      .finally(() => {
        this._alertService.success('Confirmation E-mail Has Been Sent');
      });
  }
}

AddAdmissionGroupCtrl.$inject = [
  '$scope',
  '$q',
  '$timeout',
  'colorService',
  'dateUtilsService',
  'mapperService',
  'jsSdk.customer',
  'jsSdk.utils',
  'organizationService',
  'alertService',
  'jsSdk.layoutTable',
  'jsSdk.layout',
  'formHelpersService',
  'jsSdk.admissionGroup',
  'jsSdk.attributionSource',
  'jsSdk.managementUser',
  'jsSdk.server',
  'permissionService',
  'jsSdk.inventory',
  'angularSlideOutPanel',
  'jsSdk.venue',
  'jsSdk.outgoingPayment',
  '$sce',
  'jsSdk.confirmationRequest',
  'supportService',
  'modalService',
  'jsSdk.booking'
];

export default AddAdmissionGroupCtrl;



// WEBPACK FOOTER //
// ./src/directives/addAdmissionGroup/controller.js